import * as React from 'react';
import { SingleOptionPanel } from './options-panel/single-option-panel';
import { PanelsProps } from './types';
import { sfNames, sfParameters } from './sf-names';

export const AccessToAssignRoles = (props: PanelsProps) => {
  const { translation, readOnly, data, formComponent, formValues, endpoints, validation,
    roleSelected, roleBasedData, fetchingRoleBasedData, accessData, updateAccessData, clearValueInStore, clearValidation } = props;

  return <SingleOptionPanel
    readOnly={readOnly}
    translation={translation}
    initialValue={data?.accessToAssignRoles}

    roleSelected={roleSelected}
    roleValue={roleBasedData && roleBasedData.accessToAssignRoles}
    accessData={accessData && accessData.accessToAssignRoles}
    updateAccessData={updateAccessData}
    fetchingRoleValue={fetchingRoleBasedData}

    formComponent={formComponent}
    formValues={formValues}
    valueName={sfParameters.role}
    formName={sfNames.accessToAssignRoles}
    validation={validation && validation[sfNames.accessToAssignRoles]}
    valueOptionsEndpoint={endpoints.role}
    valueLabel={translation.access_to_assign_roles_field}
    panelLabel={translation.access_to_assign_roles_group}
    addButtonText={translation.add_roles_button_text}
    displaySelectAll={true}
    clearValueInStore={clearValueInStore}
    clearValidation={clearValidation}
  />;
};
